import { topicsData } from '@/mocks/comicData';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {topicsData.title}
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.items.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 cursor-pointer hover:border-accent-300 hover:bg-accent-50 transition-colors"
            >
              <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}